// import { 
//   Box, 
//   Container, 
//   Typography, 
//   Grid, 
//   Card,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Stack,
//   Button,
//   Paper,
//   Chip
// } from '@mui/material';
// import {
//   Article as ArticleIcon,
//   Edit as EditIcon,
//   Photo as PhotoIcon,
//   Category as CategoryIcon,
//   Comment as CommentIcon,
//   Star as StarIcon,
//   Schedule as ScheduleIcon,
//   Approval as ApprovalIcon,
//   People as PeopleIcon,
//   Rss as RssIcon,
//   SmartToy as BotIcon,
//   CheckCircle as CheckIcon,
//   Newspaper as NewspaperIcon,
//   Image as ImageIcon,
//   Announcement as AnnouncementIcon,
//   Person as PersonIcon
// } from '@mui/icons-material';
// import { useState } from 'react';

// const ContentManagementPage = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);

//   // Ana Özellikler
//   const mainFeatures = [
//     {
//       icon: <EditIcon sx={{ fontSize: 50 }} />,
//       title: "Gelişmiş WYSIWYG Editör",
//       description: "Word gibi kolay kullanımlı editör ile profesyonel içerik oluşturun",
//       color: "#1e40af",
//       gradient: "linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)"
//     },
//     {
//       icon: <PhotoIcon sx={{ fontSize: 50 }} />,
//       title: "Çoklu Medya Desteği",
//       description: "Resim, video ve galeri yönetimiyle zengin içerikler",
//       color: "#dc2626",
//       gradient: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)"
//     },
//     {
//       icon: <StarIcon sx={{ fontSize: 50 }} />,
//       title: "Haber Havuzu Sistemi",
//       description: "Tüm haberlerinizi merkezi havuzda toplayın ve yönetin",
//       color: "#059669",
//       gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)"
//     },
//     {
//       icon: <CategoryIcon sx={{ fontSize: 50 }} />,
//       title: "Kategori & Etiket Yönetimi",
//       description: "Esnek kategori yapısı ve dinamik etiketleme",
//       color: "#7c3aed",
//       gradient: "linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)"
//     },
//     {
//       icon: <CommentIcon sx={{ fontSize: 50 }} />,
//       title: "Yorum Yönetimi",
//       description: "Gelişmiş moderasyon araçları ile yorum kontrolü",
//       color: "#ea580c",
//       gradient: "linear-gradient(135deg, #ea580c 0%, #f97316 100%)"
//     },
//     {
//       icon: <ScheduleIcon sx={{ fontSize: 50 }} />,
//       title: "Yayın Tarihi Planlama",
//       description: "İçeriklerinizi istediğiniz tarih ve saatte yayınlayın",
//       color: "#0891b2",
//       gradient: "linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)"
//     },
//     {
//       icon: <ApprovalIcon sx={{ fontSize: 50 }} />,
//       title: "Haber Onay İş Akışı",
//       description: "Editör onayı ile kalite kontrolü ve yayın süreçleri",
//       color: "#db2777",
//       gradient: "linear-gradient(135deg, #db2777 0%, #ec4899 100%)"
//     },
//     {
//       icon: <PeopleIcon sx={{ fontSize: 50 }} />,
//       title: "Çoklu Yazar Desteği",
//       description: "Birden fazla yazarla işbirliği yapın, yetkilendirin",
//       color: "#16a34a",
//       gradient: "linear-gradient(135deg, #16a34a 0%, #22c55e 100%)"
//     }
//   ];

//   // İçerik Türleri
//   const contentTypes = [
//     {
//       icon: <NewspaperIcon sx={{ fontSize: 40 }} />,
//       title: "Haberler",
//       description: "Güncel haber yönetimi",
//       color: "#1e40af"
//     },
//     {
//       icon: <ArticleIcon sx={{ fontSize: 40 }} />,
//       title: "E-Gazete",
//       description: "Dijital gazete yayını",
//       color: "#dc2626"
//     },
//     {
//       icon: <ImageIcon sx={{ fontSize: 40 }} />,
//       title: "Foto Galeri",
//       description: "Görsel içerik yönetimi",
//       color: "#059669"
//     },
//     {
//       icon: <EditIcon sx={{ fontSize: 40 }} />,
//       title: "Köşe Yazıları",
//       description: "Yazar profilleri ve yazıları",
//       color: "#7c3aed"
//     },
//     {
//       icon: <AnnouncementIcon sx={{ fontSize: 40 }} />,
//       title: "Duyurular",
//       description: "Önemli duyurular",
//       color: "#ea580c"
//     },
//     {
//       icon: <PersonIcon sx={{ fontSize: 40 }} />,
//       title: "Biyografiler",
//       description: "Kişi profilleri",
//       color: "#0891b2"
//     }
//   ];

//   // RSS ve Entegrasyon Özellikleri
//   const integrationFeatures = [
//     "RSS feed okuyucu ve yayıncı",
//     "Haber ajansı entegrasyonu",
//     "Otomatik haber çekme",
//     "Dış kaynak yönetimi",
//     "Kaynak bazlı filtreleme"
//   ];

//   return (
//     <Box>
//       {/* Hero Section */}
//       <Box
//         sx={{
//           py: { xs: 10, md: 16 },
//           background: `
//             linear-gradient(
//               135deg,
//               #0f172a 0%,
//               #1e293b 25%,
//               #334155 50%,
//               #475569 75%,
//               #64748b 100%
//             )
//           `,
//           position: 'relative',
//           overflow: 'hidden',
//           color: 'white',
//           '&::before': {
//             content: '""',
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background: `
//               radial-gradient(circle at 20% 20%, rgba(59, 130, 246, 0.15) 0%, transparent 50%),
//               radial-gradient(circle at 80% 80%, rgba(139, 92, 246, 0.15) 0%, transparent 50%)
//             `,
//             pointerEvents: 'none'
//           }
//         }}
//       >
//         <Container maxWidth="xl">
//           <Box sx={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
//             <Box
//               sx={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 width: 100,
//                 height: 100,
//                 borderRadius: '50%',
//                 background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
//                 mb: 4,
//                 mx: 'auto'
//               }}
//             >
//               <ArticleIcon sx={{ fontSize: 60, color: 'white' }} />
//             </Box>

//             <Typography
//               variant="overline"
//               sx={{
//                 fontSize: '0.9rem',
//                 fontWeight: 900,
//                 letterSpacing: '0.15em',
//                 color: '#3b82f6',
//                 mb: 2,
//                 display: 'block',
//                 textTransform: 'uppercase'
//               }}
//             >
//               HABER YÖNETİMİ SİSTEMİ
//             </Typography>

//             <Typography
//               variant="h1"
//               sx={{
//                 fontSize: { xs: '2.5rem', md: '4.5rem' },
//                 fontWeight: 800,
//                 mb: 4,
//                 background: 'linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//                 fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
//                 lineHeight: 1.1
//               }}
//             >
//               Profesyonel İçerik Yönetimi
//             </Typography>

//             <Typography
//               variant="h5"
//               sx={{
//                 fontSize: { xs: '1.2rem', md: '1.5rem' },
//                 color: 'rgba(255,255,255,0.8)',
//                 maxWidth: 800,
//                 mx: 'auto',
//                 lineHeight: 1.6,
//                 fontWeight: 400,
//                 mb: 6
//               }}
//             >
//               Word gibi kolay editör, çoklu medya desteği, haber havuzu ve editör onay sistemi ile 
//               profesyonel haber yönetimi deneyimi
//             </Typography>

//             <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
//               <Button
//                 variant="contained"
//                 size="large"
//                 sx={{
//                   background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
//                   color: 'white',
//                   px: 5,
//                   py: 2,
//                   fontSize: '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   textTransform: 'none',
//                   '&:hover': {
//                     background: 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)',
//                     transform: 'translateY(-2px)',
//                     boxShadow: '0 10px 30px rgba(59, 130, 246, 0.4)'
//                   },
//                   transition: 'all 0.3s ease'
//                 }}
//               >
//                 Demo İzle
//               </Button>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 sx={{
//                   borderColor: 'white',
//                   color: 'white',
//                   px: 5,
//                   py: 2,
//                   fontSize: '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   borderWidth: 2,
//                   textTransform: 'none',
//                   '&:hover': {
//                     borderWidth: 2,
//                     background: 'rgba(255, 255, 255, 0.1)',
//                     transform: 'translateY(-2px)'
//                   },
//                   transition: 'all 0.3s ease'
//                 }}
//               >
//                 Tüm Özellikleri Gör
//               </Button>
//             </Stack>
//           </Box>
//         </Container>
//       </Box>

//       {/* Ana Özellikler Grid */}
//       <Box sx={{ py: { xs: 10, md: 16 }, background: '#f8fafc' }}>
//         <Container maxWidth="xl">
//           <Box sx={{ textAlign: 'center', mb: 10 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontSize: { xs: '2.5rem', md: '3.5rem' },
//                 fontWeight: 800,
//                 mb: 3,
//                 background: 'linear-gradient(135deg, #1e293b 0%, #1e40af 100%)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent'
//               }}
//             >
//               Kapsamlı İçerik Yönetimi
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 color: '#64748b',
//                 maxWidth: 700,
//                 mx: 'auto',
//                 lineHeight: 1.6
//               }}
//             >
//               Her ihtiyacınız için gelişmiş özellikler
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {mainFeatures.map((feature, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Paper
//                   elevation={0}
//                   onMouseEnter={() => setHoveredCard(index)}
//                   onMouseLeave={() => setHoveredCard(null)}
//                   sx={{
//                     p: 4,
//                     height: '100%',
//                     background: 'white',
//                     border: '1px solid #e2e8f0',
//                     borderRadius: 4,
//                     textAlign: 'center',
//                     cursor: 'pointer',
//                     transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
//                     position: 'relative',
//                     overflow: 'hidden',
//                     '&::before': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       right: 0,
//                       height: 4,
//                       background: feature.gradient,
//                       transform: hoveredCard === index ? 'scaleX(1)' : 'scaleX(0)',
//                       transformOrigin: 'left',
//                       transition: 'transform 0.3s ease'
//                     },
//                     '&:hover': {
//                       transform: 'translateY(-8px)',
//                       boxShadow: `0 20px 40px ${feature.color}20`,
//                       borderColor: feature.color
//                     }
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'inline-flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       width: 80,
//                       height: 80,
//                       borderRadius: 3,
//                       background: `${feature.color}15`,
//                       color: feature.color,
//                       mb: 3,
//                       transition: 'all 0.4s ease',
//                       transform: hoveredCard === index ? 'scale(1.1) rotate(5deg)' : 'scale(1)'
//                     }}
//                   >
//                     {feature.icon}
//                   </Box>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 700,
//                       mb: 2,
//                       color: '#1e293b',
//                       fontSize: '1.1rem'
//                     }}
//                   >
//                     {feature.title}
//                   </Typography>

//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: '#64748b',
//                       lineHeight: 1.6
//                     }}
//                   >
//                     {feature.description}
//                   </Typography>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* İçerik Türleri */}
//       <Box sx={{ py: { xs: 10, md: 16 }, background: 'white' }}>
//         <Container maxWidth="xl">
//           <Box sx={{ textAlign: 'center', mb: 10 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontSize: { xs: '2.5rem', md: '3.5rem' },
//                 fontWeight: 800,
//                 mb: 3,
//                 background: 'linear-gradient(135deg, #1e293b 0%, #dc2626 100%)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent'
//               }}
//             >
//               Çeşitli İçerik Türleri
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 color: '#64748b',
//                 maxWidth: 700,
//                 mx: 'auto'
//               }}
//             >
//               Her türlü içeriği yönetin
//             </Typography>
//           </Box>

//           <Grid container spacing={3}>
//             {contentTypes.map((type, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <Card
//                   sx={{
//                     p: 4,
//                     height: '100%',
//                     background: `${type.color}05`,
//                     border: `2px solid ${type.color}20`,
//                     borderRadius: 3,
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       background: `${type.color}10`,
//                       borderColor: type.color,
//                       transform: 'translateY(-5px)',
//                       boxShadow: `0 10px 30px ${type.color}30`
//                     }
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       mb: 2
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         width: 60,
//                         height: 60,
//                         borderRadius: 2,
//                         background: `${type.color}20`,
//                         color: type.color,
//                         mr: 2
//                       }}
//                     >
//                       {type.icon}
//                     </Box>
//                     <Box>
//                       <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b', mb: 0.5 }}>
//                         {type.title}
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#64748b' }}>
//                         {type.description}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* RSS ve Entegrasyon */}
//       <Box
//         sx={{
//           py: { xs: 10, md: 16 },
//           background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
//           color: 'white'
//         }}
//       >
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   height: '100%'
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: 'inline-flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 200,
//                     height: 200,
//                     borderRadius: '50%',
//                     background: 'rgba(255, 255, 255, 0.1)',
//                     backdropFilter: 'blur(10px)',
//                     border: '2px solid rgba(255, 255, 255, 0.2)'
//                   }}
//                 >
//                   <BotIcon sx={{ fontSize: 100, color: 'white' }} />
//                 </Box>
//               </Box>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <Typography
//                 variant="h3"
//                 sx={{
//                   fontSize: { xs: '2rem', md: '3rem' },
//                   fontWeight: 800,
//                   mb: 3
//                 }}
//               >
//                 RSS ve Haber Ajansı Entegrasyonu
//               </Typography>
//               <Typography
//                 variant="h6"
//                 sx={{
//                   mb: 4,
//                   opacity: 0.9,
//                   lineHeight: 1.6
//                 }}
//               >
//                 Otomatik haber çekme ve dış kaynak yönetimi
//               </Typography>
//               <List>
//                 {integrationFeatures.map((feature, index) => (
//                   <ListItem key={index} sx={{ px: 0, py: 1 }}>
//                     <ListItemIcon sx={{ minWidth: 40 }}>
//                       <CheckIcon sx={{ color: 'white', fontSize: 24 }} />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={feature}
//                       primaryTypographyProps={{
//                         fontSize: '1.1rem',
//                         fontWeight: 500
//                       }}
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* CTA Section */}
//       <Box
//         sx={{
//           py: { xs: 10, md: 16 },
//           background: '#0f172a',
//           color: 'white',
//           textAlign: 'center'
//         }}
//       >
//         <Container maxWidth="md">
//           <Typography
//             variant="h2"
//             sx={{
//               fontSize: { xs: '2.5rem', md: '3.5rem' },
//               fontWeight: 800,
//               mb: 3
//             }}
//           >
//             Haber Yönetimini Profesyonelleştirin
//           </Typography>
//           <Typography
//             variant="h6"
//             sx={{
//               mb: 6,
//               opacity: 0.9,
//               lineHeight: 1.6
//             }}
//           >
//             Güçlü içerik yönetim sistemi ile haber sitenizi bir üst seviyeye taşıyın
//           </Typography>
//           <Button
//             variant="contained"
//             size="large"
//             sx={{
//               background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
//               color: 'white',
//               px: 6,
//               py: 2.5,
//               fontSize: '1.2rem',
//               fontWeight: 700,
//               borderRadius: 2,
//               textTransform: 'none',
//               '&:hover': {
//                 background: 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)',
//                 transform: 'translateY(-2px)',
//                 boxShadow: '0 10px 30px rgba(59, 130, 246, 0.4)'
//               },
//               transition: 'all 0.3s ease'
//             }}
//           >
//             Ücretsiz Deneyin
//           </Button>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default ContentManagementPage;


import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Stack,
  Paper,
  Avatar,
  IconButton,
  Tabs,
  Tab
} from '@mui/material';
import {
  Article as ArticleIcon,
  Edit as EditIcon,
  Image as ImageIcon,
  VideoLibrary as VideoIcon,
  Category as CategoryIcon,
  Label as TagIcon,
  Schedule as ScheduleIcon,
  Visibility as ViewIcon,
  CheckCircle as CheckIcon,
  Person as PersonIcon,
  Comment as CommentIcon,
  TrendingUp as TrendingIcon,
  ArrowForward as ArrowIcon,
  PlayCircle as PlayIcon,
  Code as CodeIcon,
  Palette as PaletteIcon,
  Speed as SpeedIcon,
  Security as SecurityIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const NewsContentManagementPage = () => {
  const navigate = useNavigate();
  const [hoveredFeature, setHoveredFeature] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [hoveredWorkflow, setHoveredWorkflow] = useState(null);

  // Hero Stats
  const heroStats = [
    { number: '10+', label: 'İçerik Türü', icon: <ArticleIcon /> },
    { number: '99.9%', label: 'Uptime', icon: <SpeedIcon /> },
    { number: '24/7', label: 'Destek', icon: <SecurityIcon /> }
  ];

  // İş Akışı Adımları
  const workflowSteps = [
    {
      step: '1',
      title: 'İçerik Oluştur',
      description: 'Güçlü editör ile haber yazın, resim ve video ekleyin',
      icon: <EditIcon />,
      color: '#3b82f6'
    },
    {
      step: '2',
      title: 'Kategori & Etiket',
      description: 'Kategorilere atayın, etiketleyin ve SEO ayarlarını yapın',
      icon: <CategoryIcon />,
      color: '#10b981'
    },
    {
      step: '3',
      title: 'Editör Onayı',
      description: 'Editör onayına gönderin veya taslak olarak kaydedin',
      icon: <CheckIcon />,
      color: '#f59e0b'
    },
    {
      step: '4',
      title: 'Yayınla',
      description: 'Hemen yayınlayın veya ileri tarihli yayın planlayın',
      icon: <ScheduleIcon />,
      color: '#8b5cf6'
    }
  ];

  // İçerik Türleri
  const contentTypes = [
    {
      icon: <ArticleIcon />,
      title: 'Haberler',
      description: 'Güncel haber içerikleri',
      count: '2,500+',
      color: '#3b82f6'
    },
    {
      icon: <EditIcon />,
      title: 'Makaleler',
      description: 'Uzun form içerikler',
      count: '850+',
      color: '#10b981'
    },
    {
      icon: <ImageIcon />,
      title: 'Foto Galeriler',
      description: 'Görsel içerik koleksiyonları',
      count: '1,200+',
      color: '#f59e0b'
    },
    {
      icon: <VideoIcon />,
      title: 'Video İçerikler',
      description: 'Video haberler ve röportajlar',
      count: '450+',
      color: '#8b5cf6'
    },
    {
      icon: <PersonIcon />,
      title: 'Köşe Yazıları',
      description: 'Yazar profilleri ve yazıları',
      count: '320+',
      color: '#ec4899'
    },
    {
      icon: <TrendingIcon />,
      title: 'Özel Haberler',
      description: 'Manşet ve öne çıkan içerikler',
      count: '180+',
      color: '#06b6d4'
    }
  ];

  // Gelişmiş Özellikler
  const advancedFeatures = [
    {
      title: 'Yayın Planlama',
      description: 'İleri tarihli yayın planlayın, otomatik yayınlama ayarlayın',
      icon: <ScheduleIcon />,
      color: '#3b82f6'
    },
    {
      title: 'Yazar Yönetimi',
      description: 'Çoklu yazar desteği, rol bazlı yetkilendirme',
      icon: <PersonIcon />,
      color: '#10b981'
    },
    {
      title: 'Yorum Moderasyonu',
      description: 'Gelişmiş yorum yönetimi ve spam filtreleme',
      icon: <CommentIcon />,
      color: '#f59e0b'
    },
    {
      title: 'İçerik Analitikleri',
      description: 'Detaylı performans raporları ve okuyucu analizleri',
      icon: <TrendingIcon />,
      color: '#8b5cf6'
    },
    {
      title: 'SEO Optimizasyonu',
      description: 'Otomatik meta tag, sitemap ve schema.org desteği',
      icon: <CodeIcon />,
      color: '#ec4899'
    },
    {
      title: 'Hızlı Erişim',
      description: 'Klavye kısayolları ve toplu işlem desteği',
      icon: <SpeedIcon />,
      color: '#06b6d4'
    }
  ];

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>

      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
          pt: { xs: 12, md: 16 },
          pb: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Dekoratif Elementler */}
        <Box
          sx={{
            position: 'absolute',
            top: -100,
            right: -100,
            width: 400,
            height: 400,
            background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
            borderRadius: '50%',
            opacity: 0.1,
            filter: 'blur(80px)'
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Chip
                label="İÇERİK YÖNETİMİ"
                sx={{
                  background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.2), rgba(247, 147, 30, 0.2))',
                  color: '#ff6b35',
                  border: '1px solid rgba(255, 107, 53, 0.3)',
                  backdropFilter: 'blur(10px)',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  mb: 3
                }}
              />

              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: '2.5rem', md: '4rem' },
                  fontWeight: 800,
                  color: 'white',
                  mb: 3,
                  lineHeight: 1.1
                }}
              >
                Güçlü Haber{' '}
                <span style={{
                  background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                  İçerik Yönetimi
                </span>
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  fontSize: { xs: '1.1rem', md: '1.3rem' },
                  lineHeight: 1.6,
                  mb: 4
                }}
              >
                Profesyonel editör, medya kütüphanesi, kategori sistemi ve daha fazlası ile
                haber içeriklerinizi kolayca yönetin.
              </Typography>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mb={6}>
                <Button
                  variant="contained"
                  size="large"
                  endIcon={<ArrowIcon />}
                  onClick={() => navigate('/contact')}
                  sx={{
                    background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                    color: 'white',
                    px: 4,
                    py: 2,
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    borderRadius: '50px',
                    textTransform: 'none',
                    boxShadow: '0 8px 32px rgba(255, 107, 53, 0.4)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #f7931e 0%, #ff6b35 100%)',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 12px 40px rgba(255, 107, 53, 0.5)'
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  İletişime Geçin
                </Button>
              </Stack>

              {/* Mini Stats */}
              <Grid container spacing={3}>
                {heroStats.map((stat, index) => (
                  <Grid item xs={4} sm={3} key={index}>
                    <Box sx={{ textAlign: 'center' }}>
                      <Box
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 50,
                          height: 50,
                          borderRadius: '50%',
                          background: 'rgba(255, 107, 53, 0.15)',
                          color: '#ff6b35',
                          mb: 1,
                          fontSize: '1.5rem'
                        }}
                      >
                        {stat.icon}
                      </Box>
                      <Typography
                        sx={{
                          color: 'white',
                          fontSize: '1.5rem',
                          fontWeight: 800
                        }}
                      >
                        {stat.number}
                      </Typography>
                      <Typography
                        sx={{
                          color: 'rgba(255,255,255,0.6)',
                          fontSize: '0.85rem'
                        }}
                      >
                        {stat.label}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 4,
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
                  border: '1px solid rgba(255,255,255,0.1)'
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800&h=600&fit=crop"
                  alt="Content Management"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />
                {/* Overlay Badge */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 20,
                    left: 20,
                    right: 20,
                    background: 'rgba(255,255,255,0.95)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: 3,
                    p: 3
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        width: 60,
                        height: 60,
                        borderRadius: 2,
                        background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '1.8rem'
                      }}
                    >
                      <EditIcon fontSize="large" />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, color: '#1a1a2e', mb: 0.5 }}>
                        Profesyonel Editör
                      </Typography>
                      <Typography sx={{ fontSize: '0.9rem', color: '#6c757d' }}>
                        TinyMCE ile güçlü içerik düzenleme
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>

        {/* Dalga Geçişi */}
        <Box
          sx={{
            position: 'absolute',
            bottom: '-130px',
            left: 0,
            width: '100%',
            overflow: 'hidden',
            lineHeight: 0
          }}
        >
          <svg
            viewBox="0 0 1440 400"
            preserveAspectRatio="none"
            style={{ width: '100%', height: '250px', display: 'block' }}
          >
            <path
              d="M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,154.7C672,149,768,171,864,181.3C960,192,1056,192,1152,176C1248,160,1344,128,1392,112L1440,96L1440,400L0,400Z"
              fill="#f8f9fa"
            />
          </svg>
        </Box>
      </Box>

      {/* Ana Özellikler Bölümü - YENİ TASARIM */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
          py: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Dekoratif Blob */}
        <Box
          sx={{
            position: 'absolute',
            top: -150,
            right: -150,
            width: 500,
            height: 500,
            background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
            borderRadius: '40% 60% 70% 30% / 40% 50% 60% 50%',
            opacity: 0.05,
            filter: 'blur(80px)'
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography
              variant="overline"
              sx={{
                color: '#ff6b35',
                fontSize: '0.9rem',
                fontWeight: 700,
                letterSpacing: '0.1em'
              }}
            >
              ANA ÖZELLİKLER
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: '#1a1a2e',
                mb: 2,
                mt: 2
              }}
            >
              Her Şey Tek Platformda
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#6c757d',
                maxWidth: 700,
                mx: 'auto'
              }}
            >
              Haber içeriklerinizi oluşturmak, düzenlemek ve yayınlamak için
              ihtiyacınız olan tüm araçlar
            </Typography>
          </Box>

          {/* Özellik 1 - Sol Resim, Sağ İçerik */}
          <Grid container spacing={6} alignItems="center" justifyContent="center" sx={{ mb: 12 }}>
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 4,
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                  '&:hover': {
                    '& img': {
                      transform: 'scale(1.05)'
                    }
                  }
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800&h=600&fit=crop"
                  alt="Content Editor"
                  style={{
                    width: '100%',
                    height: '300px',
                    display: 'block',
                    transition: 'transform 0.6s ease'
                  }}
                />
                {/* Floating Badge */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 20,
                    right: 20,
                    background: 'white',
                    borderRadius: 3,
                    p: 2,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                  }}
                >
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: 2,
                      background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '1.5rem'
                    }}
                  >
                    <EditIcon />
                  </Box>
                  <Box>
                    <Typography sx={{ fontWeight: 700, fontSize: '0.9rem', color: '#1a1a2e' }}>
                      TinyMCE Editor
                    </Typography>
                    <Typography sx={{ fontSize: '0.75rem', color: '#6c757d' }}>
                      Profesyonel Düzenleme
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: '2rem', md: '2.5rem' },
                  fontWeight: 800,
                  color: '#1a1a2e',
                  mb: 2
                }}
              >
                Güçlü İçerik Editörü
              </Typography>

              <Typography
                sx={{
                  fontSize: '1.1rem',
                  color: '#3b82f6',
                  fontWeight: 600,
                  mb: 3
                }}
              >
                TinyMCE ile Profesyonel Düzenleme
              </Typography>

              <Typography
                sx={{
                  color: '#6c757d',
                  fontSize: '1.05rem',
                  lineHeight: 1.8,
                  mb: 4
                }}
              >
                Gelişmiş WYSIWYG editör ile zengin içerikler oluşturun. Kod bilgisi
                gerektirmeden profesyonel haberler yazın, resim ve video ekleyin.
              </Typography>

              {/* Özellik Listesi - 2 Kolon */}
              <Grid container spacing={2}>
                {[
                  'Rich Text Formatting',
                  'Resim & Video Ekleme',
                  'Tablo ve Liste Desteği',
                  'Kod Blokları',
                  'Özel HTML Desteği',
                  'Otomatik Kaydetme'
                ].map((item, idx) => (
                  <Grid item xs={12} md={6} key={idx}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Box
                        sx={{
                          width: 24,
                          height: 24,
                          borderRadius: '50%',
                          background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white',
                          fontSize: '0.7rem',
                          fontWeight: 700,
                          flexShrink: 0
                        }}
                      >
                        ✓
                      </Box>
                      <Typography
                        sx={{
                          fontSize: '0.95rem',
                          color: '#495057',
                          fontWeight: 500
                        }}
                      >
                        {item}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          {/* Özellik 2 - Sağ Resim, Sol İçerik */}
          <Grid container spacing={6} alignItems="center" justifyContent="center" sx={{ mb: 12 }}>
            <Grid item xs={12} md={4} sx={{ order: { xs: 2, md: 1 } }}>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: '2rem', md: '2.5rem' },
                  fontWeight: 800,
                  color: '#1a1a2e',
                  mb: 2
                }}
              >
                Medya Kütüphanesi
              </Typography>

              <Typography
                sx={{
                  fontSize: '1.1rem',
                  color: '#10b981',
                  fontWeight: 600,
                  mb: 3
                }}
              >
                Gelişmiş Görsel Yönetimi
              </Typography>

              <Typography
                sx={{
                  color: '#6c757d',
                  fontSize: '1.05rem',
                  lineHeight: 1.8,
                  mb: 4
                }}
              >
                Resim, video ve galeri yönetimi tek yerden. Otomatik optimizasyon ve
                CDN entegrasyonu ile hızlı yükleme garantisi.
              </Typography>
              <Grid container spacing={2}>
                {[
                  'Toplu Resim Yükleme',
                  'Otomatik Resize & Crop',
                  'Foto Galeri Oluşturma', 
                  'Video Entegrasyonu',
                  'Alt Text & SEO',
                  'CDN Optimizasyonu'
                ].map((item, idx) => (
                  <Grid item xs={12} md={6} key={idx}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Box
                        sx={{
                          width: 24,
                          height: 24,
                          borderRadius: '50%',
                          background: 'linear-gradient(90deg, #10b981 0%, #047857 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white',
                          fontSize: '0.7rem',
                          fontWeight: 700,
                          flexShrink: 0
                        }}
                      >
                        ✓
                      </Box>
                      <Typography
                        sx={{
                          fontSize: '0.95rem',
                          color: '#495057',
                          fontWeight: 500
                        }}
                      >
                        {item}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12} md={5} sx={{ order: { xs: 1, md: 2 } }}>
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 4,
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                  '&:hover': {
                    '& img': {
                      transform: 'scale(1.05)'
                    }
                  }
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1600132806608-231446b2e7af?w=800&h=600&fit=crop"
                  alt="Media Library"
                  style={{
                    width: '100%',
                    height: '300px',
                    display: 'block',
                    transition: 'transform 0.6s ease'
                  }}
                />
                {/* Stats Overlay */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 20,
                    left: 20,
                    right: 20,
                    display: 'flex',
                    gap: 2
                  }}
                >
                  {[
                    { icon: <ImageIcon />, label: '2.5K', color: '#10b981' },
                    { icon: <VideoIcon />, label: '450', color: '#3b82f6' }
                  ].map((stat, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        background: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: 2,
                        p: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                      }}
                    >
                      <Box sx={{ color: stat.color, fontSize: '1.2rem' }}>
                        {stat.icon}
                      </Box>
                      <Typography sx={{ fontWeight: 700, fontSize: '0.9rem', color: '#1a1a2e' }}>
                        {stat.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>
          </Grid>

          {/* Özellik 3 - Sol Resim, Sağ İçerik */}
          <Grid container spacing={6} alignItems="center" justifyContent="center" sx={{ mb: 12 }}>
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 4,
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?w=800&h=600&fit=crop"
                  alt="Category System"
                  style={{
                    width: '100%',
                    height: '300px',
                    display: 'block'
                  }}
                />
                {/* Category Tags Overlay */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 20,
                    left: 20,
                    right: 20,
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1.5
                  }}
                >
                  {['Teknoloji', 'Ekonomi', 'Spor', 'Sağlık', 'Kültür'].map((cat, idx) => (
                    <Chip
                      key={idx}
                      label={cat}
                      sx={{
                        background: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        fontWeight: 600,
                        fontSize: '0.85rem',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        '&:hover': {
                          background: '#f59e0b',
                          color: 'white'
                        }
                      }}
                    />
                  ))}
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>

              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: '2rem', md: '2.5rem' },
                  fontWeight: 800,
                  color: '#1a1a2e',
                  mb: 2
                }}
              >
                Akıllı Kategori Sistemi
              </Typography>

              <Typography
                sx={{
                  fontSize: '1.1rem',
                  color: '#f59e0b',
                  fontWeight: 600,
                  mb: 3
                }}
              >
                Sınırsız Organizasyon
              </Typography>

              <Typography
                sx={{
                  color: '#6c757d',
                  fontSize: '1.05rem',
                  lineHeight: 1.8,
                  mb: 4
                }}
              >
                Hiyerarşik kategori yapısı ile içeriklerinizi mükemmel organize edin.
                Alt kategoriler ve çoklu atama desteği ile esnek yönetim.
              </Typography>

              {/* Icon Grid */}
              <Grid container spacing={2}>
                {[
                  'Sınırsız Kategori',
                  'Çoklu Kategori Atama',
                  'Alt Kategori Desteği',
                  'Özel URL Yapısı',
                  'SEO Optimizasyonu'
                ].map((item, idx) => (
                  <Grid item xs={12} md={6} key={idx}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Box
                        sx={{
                          width: 24,
                          height: 24,
                          borderRadius: '50%',
                          background: 'linear-gradient(90deg, #f59e0b 0%,rgb(206, 133, 7) 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white',
                          fontSize: '0.7rem',
                          fontWeight: 700,
                          flexShrink: 0
                        }}
                      >
                        ✓
                      </Box>
                      <Typography
                        sx={{
                          fontSize: '0.95rem',
                          color: '#495057',
                          fontWeight: 500
                        }}
                      >
                        {item}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          {/* Özellik 4 - Sağ Resim, Sol İçerik */}
          <Grid container spacing={6} alignItems="center" justifyContent="center">
            <Grid item xs={12} md={4} sx={{ order: { xs: 2, md: 1 } }}>

              <Typography
                variant="h3"
                sx={{
                  fontSize: { xs: '2rem', md: '2.5rem' },
                  fontWeight: 800,
                  color: '#1a1a2e',
                  mb: 2
                }}
              >
                Etiket Yönetimi
              </Typography>

              <Typography
                sx={{
                  fontSize: '1.1rem',
                  color: '#8b5cf6',
                  fontWeight: 600,
                  mb: 3
                }}
              >
                Akıllı İçerik Etiketleme
              </Typography>

              <Typography
                sx={{
                  color: '#6c757d',
                  fontSize: '1.05rem',
                  lineHeight: 1.8,
                  mb: 4
                }}
              >
                Otomatik etiket önerileri ve popüler etiketler ile içeriklerinizi
                kolayca etiketleyin. Gelişmiş arama ve filtreleme özellikleri.
              </Typography>

              {/* Numbered List */}
              <Grid container spacing={2}>
                {[
                  'Otomatik Etiket Önerileri',
                  'Popüler Etiketler',
                  'Gelişmiş Arama',
                  'Etiket Birleştirme',
                  'Etiket Bulut Görünümü',
                  'Toplu Etiket Düzenleme'
                ].map((item, idx) => (
                  <Grid item xs={12} md={6} key={idx}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Box
                        sx={{
                          width: 24,
                          height: 24,
                          borderRadius: '50%',
                          background: 'linear-gradient(90deg, #8b5cf6 0%,rgb(94, 55, 185) 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white',
                          fontSize: '0.7rem',
                          fontWeight: 700,
                          flexShrink: 0
                        }}
                      >
                        ✓
                      </Box>
                      <Typography
                        sx={{
                          fontSize: '0.95rem',
                          color: '#495057',
                          fontWeight: 500
                        }}
                      >
                        {item}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12} md={5} sx={{ order: { xs: 1, md: 2 } }}>
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 4,
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&h=600&fit=crop"
                  alt="Tag Management"
                  style={{
                    width: '100%',
                    height: '300px',
                    display: 'block'
                  }}
                />
                {/* Tag Cloud Overlay */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 20,
                    left: 20,
                    right: 20,
                    bottom: 20,
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignContent: 'center',
                    justifyContent: 'center',
                    gap: 1.5,
                    background: 'rgba(0,0,0,0.4)',
                    backdropFilter: 'blur(5px)',
                    borderRadius: 3,
                    p: 3
                  }}
                >
                  {['AI', 'Teknoloji', 'İnovasyon', 'Dijital', 'Yazılım', 'Veri', 'Analiz', 'Cloud'].map((tag, idx) => (
                    <Chip
                      key={idx}
                      label={tag}
                      sx={{
                        background: 'rgba(139, 92, 246, 0.9)',
                        color: 'white',
                        fontWeight: 600,
                        fontSize: idx % 2 === 0 ? '1rem' : '0.85rem',
                        '&:hover': {
                          background: '#8b5cf6'
                        }
                      }}
                    />
                  ))}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* İş Akışı Bölümü */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
          py: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Dekoratif Element */}
        <Box
          sx={{
            position: 'absolute',
            bottom: -100,
            left: -100,
            width: 400,
            height: 400,
            background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
            borderRadius: '50%',
            opacity: 0.1,
            filter: 'blur(80px)'
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography
              variant="overline"
              sx={{
                color: '#ff6b35',
                fontSize: '0.9rem',
                fontWeight: 700,
                letterSpacing: '0.1em'
              }}
            >
              İŞ AKIŞI
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: 'white',
                mb: 2,
                mt: 2
              }}
            >
              4 Adımda Haber Yayınlayın
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                maxWidth: 700,
                mx: 'auto'
              }}
            >
              Basit ve etkili iş akışı ile dakikalar içinde içerik oluşturun ve yayınlayın
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {workflowSteps.map((step, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Box
                  onMouseEnter={() => setHoveredWorkflow(index)}
                  onMouseLeave={() => setHoveredWorkflow(null)}
                  sx={{
                    textAlign: 'center',
                    p: 4,
                    borderRadius: 4,
                    background: hoveredWorkflow === index
                      ? `${step.color}15`
                      : 'rgba(255,255,255,0.05)',
                    border: hoveredWorkflow === index
                      ? `2px solid ${step.color}50`
                      : '2px solid rgba(255,255,255,0.1)',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    transform: hoveredWorkflow === index ? 'translateY(-10px)' : 'none',
                    position: 'relative'
                  }}
                >
                  {/* Step Number */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: -20,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: 40,
                      height: 40,
                      borderRadius: '50%',
                      background: step.color,
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 800,
                      fontSize: '1.2rem',
                      boxShadow: `0 4px 16px ${step.color}60`
                    }}
                  >
                    {step.step}
                  </Box>

                  {/* Icon */}
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 80,
                      height: 80,
                      borderRadius: 3,
                      background: hoveredWorkflow === index
                        ? step.color
                        : `${step.color}20`,
                      color: hoveredWorkflow === index ? 'white' : step.color,
                      mb: 3,
                      mt: 2,
                      fontSize: '2rem',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {step.icon}
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      color: 'white',
                      fontWeight: 700,
                      mb: 2
                    }}
                  >
                    {step.title}
                  </Typography>

                  <Typography
                    sx={{
                      color: 'rgba(255,255,255,0.7)',
                      fontSize: '0.95rem',
                      lineHeight: 1.6
                    }}
                  >
                    {step.description}
                  </Typography>

                  {/* Arrow */}
                  {index < workflowSteps.length - 1 && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        right: -20,
                        transform: 'translateY(-50%)',
                        color: 'rgba(255,255,255,0.3)',
                        fontSize: '2rem',
                        display: { xs: 'none', md: 'block' }
                      }}
                    >
                      →
                    </Box>
                  )}
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Box
        sx={{
          background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 50%, #f8f9fa 100%)',
          py: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Nokta Pattern */}
        <Box
          sx={{
            position: 'absolute',
            top: 50,
            right: 50,
            width: 200,
            height: 200,
            backgroundImage: 'radial-gradient(circle, rgba(255, 107, 53, 0.1) 2px, transparent 2px)',
            backgroundSize: '20px 20px'
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Grid container spacing={6} alignItems="center">
            {/* Sol Taraf - Büyük Görsel */}
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 4,
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=800&fit=crop"
                  alt="Advanced Features"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />

                {/* Floating Cards */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 30,
                    right: 30,
                    background: 'rgba(255,255,255,0.95)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: 3,
                    p: 2,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                    animation: 'float 4s ease-in-out infinite'
                  }}
                >
                  <Stack direction="row" spacing={1.5} alignItems="center">
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 2,
                        background: 'linear-gradient(135deg, #10b981 0%, #047857 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white'
                      }}
                    >
                      <CheckIcon />
                    </Box>
                    <Box>
                      <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#1a1a2e' }}>
                        Yayında
                      </Typography>
                      <Typography sx={{ fontSize: '1.2rem', fontWeight: 800, color: '#10b981' }}>
                        1,892
                      </Typography>
                    </Box>
                  </Stack>
                </Box>

                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 30,
                    left: 30,
                    background: 'rgba(255,255,255,0.95)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: 3,
                    p: 2,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                    animation: 'float 4s ease-in-out infinite 1s'
                  }}
                >
                  <Stack direction="row" spacing={1.5} alignItems="center">
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 2,
                        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white'
                      }}
                    >
                      <TrendingIcon />
                    </Box>
                    <Box>
                      <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#1a1a2e' }}>
                        Görüntülenme
                      </Typography>
                      <Typography sx={{ fontSize: '1.2rem', fontWeight: 800, color: '#3b82f6' }}>
                        1.2M
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              </Box>
            </Grid>

            {/* Sağ Taraf - Özellikler */}
            <Grid item xs={12} md={7}>
              <Typography
                variant="overline"
                sx={{
                  color: '#ff6b35',
                  fontSize: '0.9rem',
                  fontWeight: 700,
                  letterSpacing: '0.1em'
                }}
              >
                GELİŞMİŞ ÖZELLİKLER
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2.5rem', md: '3rem' },
                  fontWeight: 800,
                  color: '#1a1a2e',
                  mb: 3,
                  mt: 2
                }}
              >
                Profesyonel Araçlar{' '}
                <span style={{ color: '#ff6b35' }}>Parmaklarınızın Ucunda</span>
              </Typography>

              <Typography
                sx={{
                  color: '#6c757d',
                  fontSize: '1.05rem',
                  lineHeight: 1.8,
                  mb: 5
                }}
              >
                Haber yönetimini kolaylaştıran ve iş akışınızı hızlandıran
                gelişmiş özellikler ile verimliliğinizi artırın.
              </Typography>

              {/* Özellik Kartları - Accordion Stili */}
              <Stack spacing={2}>
                {advancedFeatures.map((feature, index) => (
                  <Paper
                    key={index}
                    sx={{
                      p: 3,
                      borderRadius: 3,
                      border: '2px solid #e2e8f0',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden',
                      '&:hover': {
                        borderColor: feature.color,
                        transform: 'translateX(8px)',
                        boxShadow: `0 8px 24px ${feature.color}20`,
                        '& .feature-number': {
                          background: feature.color,
                          color: 'white'
                        },
                        '& .feature-arrow': {
                          opacity: 1,
                          transform: 'translateX(0)'
                        }
                      },
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: 4,
                        background: feature.color,
                        opacity: 0,
                        transition: 'opacity 0.3s ease'
                      },
                      '&:hover::before': {
                        opacity: 1
                      }
                    }}
                  >
                    <Stack direction="row" spacing={3}  sx={{flexDirection: {xs:'column', sm:'row'}, gap:1 , alignItems:{xs : 'flex-start', sm : 'center'}}}>
                      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap:1}}>
                         {/* Number Badge */}
                      <Box
                        className="feature-number"
                        sx={{
                          width: 50,
                          height: 60,
                          borderRadius: 2,
                          background: `${feature.color}15`,
                          color: feature.color,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 800,
                          fontSize: '1.3rem',
                          flexShrink: 0,
                          transition: 'all 0.3s ease'
                        }}
                      >
                        {String(index + 1).padStart(2, '0')}
                      </Box>

                      {/* Icon */}
                      <Box
                        sx={{
                          width: 60,
                          height: 60,
                          borderRadius: 2,
                          background: `${feature.color}15`,
                          color: feature.color,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '1.8rem',
                          flexShrink: 0
                        }}
                      >
                        {feature.icon}
                      </Box>
                      </Box>

                      {/* Content */}
                      <Box sx={{ flex: 1 , ml :{xs:'0px !important', sm:'10px !important'}}}>
                        <Typography
                          sx={{
                            fontWeight: 700,
                            fontSize: '1.1rem',
                            color: '#1a1a2e',
                            mb: 0.5
                          }}
                        >
                          {feature.title}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '0.95rem',
                            color: '#6c757d',
                            lineHeight: 1.6
                          }}
                        >
                          {feature.description}
                        </Typography>
                      </Box>

                      {/* Arrow */}
                      <IconButton
                        className="feature-arrow"
                        sx={{
                          color: feature.color,
                          opacity: 0,
                          transform: 'translateX(-10px)',
                          transition: 'all 0.3s ease'
                        }}
                      >
                        <ArrowIcon />
                      </IconButton>
                    </Stack>
                  </Paper>
                ))}
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* İçerik Türleri - YENİ TASARIM */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
          py: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Dekoratif Elementler */}
        <Box
          sx={{
            position: 'absolute',
            top: 100,
            left: -100,
            width: 400,
            height: 400,
            background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
            borderRadius: '40% 60% 70% 30% / 40% 50% 60% 50%',
            opacity: 0.1,
            filter: 'blur(80px)',
            animation: 'morph 10s ease-in-out infinite'
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            bottom: 100,
            right: -100,
            width: 300,
            height: 300,
            background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
            borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%',
            opacity: 0.1,
            filter: 'blur(60px)',
            animation: 'morph 12s ease-in-out infinite reverse'
          }}
        />

        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography
              variant="overline"
              sx={{
                color: '#ff6b35',
                fontSize: '0.9rem',
                fontWeight: 700,
                letterSpacing: '0.1em'
              }}
            >
              İÇERİK TÜRLERİ
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: 'white',
                mb: 2,
                mt: 2
              }}
            >
              Çeşitli İçerik Formatları
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                maxWidth: 700,
                mx: 'auto'
              }}
            >
              Farklı içerik türleri ile zengin bir haber platformu oluşturun
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {contentTypes.map((type, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    background: 'rgba(255,255,255,0.05)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    borderRadius: 4,
                    p: 4,
                    textAlign: 'center',
                    position: 'relative',
                    overflow: 'hidden',
                    transition: 'all 0.4s ease',
                    cursor: 'pointer',
                    '&:hover': {
                      transform: 'translateY(-12px)',
                      background: 'rgba(255,255,255,0.08)',
                      borderColor: type.color,
                      boxShadow: `0 20px 40px ${type.color}30`,
                      '& .type-icon-box': {
                        transform: 'scale(1.15) rotate(10deg)',
                        background: type.color,
                        color: 'white'
                      },
                      '& .type-count': {
                        transform: 'scale(1.1)'
                      }
                    },
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: 4,
                      background: `linear-gradient(90deg, ${type.color}, transparent)`,
                      opacity: 0,
                      transition: 'opacity 0.3s ease'
                    },
                    '&:hover::before': {
                      opacity: 1
                    }
                  }}
                >
                  {/* Icon */}
                  <Box
                    className="type-icon-box"
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 90,
                      height: 90,
                      borderRadius: 3,
                      background: `${type.color}20`,
                      color: type.color,
                      mb: 3,
                      fontSize: '2.5rem',
                      transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                      position: 'relative',
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        inset: -8,
                        borderRadius: 3,
                        border: `2px solid ${type.color}30`,
                        opacity: 0,
                        transition: 'opacity 0.3s ease'
                      }
                    }}
                  >
                    {type.icon}
                  </Box>

                  {/* Title */}
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      color: 'white',
                      mb: 1.5
                    }}
                  >
                    {type.title}
                  </Typography>

                  {/* Description */}
                  <Typography
                    sx={{
                      color: 'rgba(255,255,255,0.6)',
                      fontSize: '0.95rem',
                      mb: 3,
                      lineHeight: 1.6
                    }}
                  >
                    {type.description}
                  </Typography>

                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>


      {/* CTA Section */}
      <Container maxWidth="md">
      <Box
        sx={{
          my: 10,
          background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
          py: { xs: 2, md: 3 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Dekoratif Pattern */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
            backgroundSize: '20px 20px',
            opacity: 0.5
          }}
        />

        <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: 'white',
                mb: 3
              }}
            >
              Hemen Başlayın
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: 'rgba(255,255,255,0.9)',
                mb: 5,
                maxWidth: 600,
                mx: 'auto'
              }}
            >
             Hemen başlayın ve kendi haber sitenizi oluşturun. 
            </Typography>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={3}
              sx={{ justifyContent: 'center' }}
            >
              <Button
                variant="contained"
                size="large"
                endIcon={<ArrowIcon />}
                sx={{
                  background: 'white',
                  color: '#ff6b35',
                  px: 6,
                  py: 2.5,
                  fontSize: '1.1rem',
                  fontWeight: 700,
                  borderRadius: '50px',
                  textTransform: 'none',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                  '&:hover': {
                    background: '#f8f9fa',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.3)'
                  }
                }}
              >
                Ücretsiz Başla
              </Button>

              <Button
                variant="outlined"
                size="large"
                sx={{
                  borderColor: 'white',
                  color: 'white',
                  px: 6,
                  py: 2.5,
                  fontSize: '1.1rem',
                  fontWeight: 700,
                  borderRadius: '50px',
                  textTransform: 'none',
                  borderWidth: 2,
                  '&:hover': {
                    background: 'rgba(255,255,255,0.1)',
                    borderColor: 'white',
                    borderWidth: 2
                  }
                }}
              >
                Demo Talep Et
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>
      </Container>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }
      `}</style>
    </Box>
  );
};

export default NewsContentManagementPage;